import { useState } from "react";
import { Dropdown, DropdownSkeleton } from "carbon-components-react";
import { Label } from "../Label";

import useSWR from "swr";
import { URL, Fetcher as F } from "../../../api";

export const ParkingSpace = ({
  id,
  className,
  style,
  filter = {},
  field = {},
  data,
  onChange,
}) => {
  const { center } = filter;
  const { key, required = false } = field;
  const title = "停車位";

  const [shouldValidate, setShouldValidate] = useState(false);
  const invalid = shouldValidate && required && data === undefined;

  const url = `${URL.parking}?center=${center?.id ?? ""}`;
  const { data: list = [] } = useSWR([url], F.withToken);
  const listWithNone = [{ id: 0, name: "無" }, ...list.slice(0)];
  const item = (listWithNone || []).find(
    (x) => x.id === (data === null ? 0 : data)
  );

  return !list ? (
    <DropdownSkeleton id={id} className={className} style={style} />
  ) : (
    <Dropdown
      id={id}
      className={className}
      style={style}
      titleText={<Label required={required}>{title}</Label>}
      label="請選擇"
      items={listWithNone}
      itemToString={(x) => x.name}
      selectedItem={item}
      invalid={invalid}
      invalidText="此為必填欄位"
      onFocus={() => setShouldValidate(false)}
      onBlur={() => setShouldValidate(true)}
      onChange={(e) => {
        const v = e.selectedItem.id;
        if (typeof onChange !== "function") return;
        onChange({ [key]: v });
      }}
    />
  );
};
